// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  padding: 3rem 6.875rem;
}
@media (max-width: 768px) {
  .footer {
    padding: 3.5rem 1rem 3rem;
  }
}
.footer__logo {
  height: 2.5925rem;
}
@media (max-width: 768px) {
  .footer__logo {
    height: 2.09125rem;
  }
}
.footer__first {
  margin-bottom: 4rem;
}
@media (max-width: 768px) {
  .footer__first {
    margin-bottom: 2rem;
  }
}
.footer__second {
  display: flex;
  flex-direction: column;
}
.footer-contacts-link {
  color: rgba(var(--grey-600));
}
.footer__contacts {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
}
.footer__contacts-links {
  display: flex;
  align-items: center;
  gap: 2rem;
  font-size: 1rem;
  font-family: var(--merriweather);
  font-weight: 300;
  line-height: 1.625;
  color: rgba(var(--grey-600));
}
@media (max-width: 768px) {
  .footer__contacts-links {
    flex-direction: column;
    align-items: flex-start;
    font-size: 0.875rem;
    gap: 1.3rem;
  }
}
.footer__contacts-social {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.footer__information {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2rem;
  font-weight: 400;
  line-height: 1.57;
  color: rgba(var(--grey-400));
}
@media (max-width: 768px) {
  .footer__information {
    flex-direction: column;
    align-items: flex-start;
    font-size: 0.875rem;
  }
}
.footer__information-items {
  display: flex;
  align-items: center;
  gap: 1rem;
}
@media (max-width: 768px) {
  .footer__information-items {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 1.5rem;
    gap: 1.5rem;
  }
}

.footer-links-group {
  display: flex;
  align-items: center;
  gap: 2rem;
}
@media (max-width: 768px) {
  .footer-links-group {
    justify-content: space-between;
    align-items: flex-start;
    font-size: 0.875rem;
    font-weight: 600;
    color: rgba(var(--grey-800));
    gap: 7rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/styles.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;AACE;EAHF;IAII,yBAAA;EAEF;AACF;AAAE;EACE,iBAAA;AAEJ;AAAI;EAHF;IAII,kBAAA;EAGJ;AACF;AAAE;EACE,mBAAA;AAEJ;AAAI;EAHF;IAII,mBAAA;EAGJ;AACF;AAAE;EACE,aAAA;EACA,sBAAA;AAEJ;AACE;EACE,4BAAA;AACJ;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;AAAN;AAEM;EAVF;IAWI,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,WAAA;EACN;AACF;AAEI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;AAFJ;AAII;EATF;IAUI,sBAAA;IACA,uBAAA;IACA,mBAAA;EADJ;AACF;AAGI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADN;AAGM;EALF;IAMI,sBAAA;IACA,uBAAA;IACA,kBAAA;IACA,WAAA;EAAN;AACF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAFF;AAIE;EALF;IAMI,8BAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;IACA,4BAAA;IACA,SAAA;EADF;AACF","sourcesContent":[".footer {\n  padding: 3rem 6.875rem;\n\n  @media (max-width: 768px) {\n    padding: 3.5rem 1rem 3rem;\n  }\n\n  &__logo {\n    height: 2.5925rem;\n\n    @media (max-width: 768px) {\n      height: 2.09125rem;\n    }\n  }\n\n  &__first {\n    margin-bottom: 4rem;\n\n    @media (max-width: 768px) {\n      margin-bottom: 2rem;\n    }\n  }\n\n  &__second {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &-contacts-link {\n    color: rgba(var(--grey-600));\n  }\n\n  &__contacts {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 2rem;\n\n    &-links {\n      display: flex;\n      align-items: center;\n      gap: 2rem;\n      font-size: 1rem;\n      font-family: var(--merriweather);\n      font-weight: 300;\n      line-height: 1.625;\n      color: rgba(var(--grey-600));\n\n      @media (max-width: 768px) {\n        flex-direction: column;\n        align-items: flex-start;\n        font-size: 0.875rem;\n        gap: 1.3rem;\n      }\n    }\n\n    &-social {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n    }\n  }\n\n  &__information {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 2rem;\n    font-weight: 400;\n    line-height: 1.57;\n    color: rgba(var(--grey-400));\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      align-items: flex-start;\n      font-size: 0.875rem;\n    }\n\n    &-items {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n\n      @media (max-width: 768px) {\n        flex-direction: column;\n        align-items: flex-start;\n        margin-top: 1.5rem;\n        gap: 1.5rem;\n      }\n    }\n  }\n}\n\n.footer-links-group {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n\n  @media (max-width: 768px) {\n    justify-content: space-between;\n    align-items: flex-start;\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: rgba(var(--grey-800));\n    gap: 7rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
